import {App} from "vue";
import {ColorEnum, ColorValue} from "@/modules/vue/enums";
import {GateTypeEnum} from "@/modules/action-points/enums";

export default {
  install(app: App<Element>) {
    app.config.globalProperties.ColorEnum = ColorEnum;
    app.config.globalProperties.IconEnum = IconEnum;
    app.config.globalProperties.GateTypeEnum = GateTypeEnum;
    app.config.globalProperties.ColorValue = ColorValue;
  },
};